// adicionar.jsx refatorado com preview e tamanho dos arquivos
import React, { useState } from 'react';
import {
  Box, Container, Typography, TextField, Button, Snackbar,
  Alert, IconButton, List, ListItem, ListItemText, ListItemSecondaryAction,
  MenuItem, Select, InputLabel, FormControl, LinearProgress, Avatar
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const estadosBrasil = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
  "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
  "RS", "RO", "RR", "SC", "SP", "SE", "TO"
];

export default function AdicionarCliente() {
  const [formData, setFormData] = useState({ nome: '', cpf_cnpj: '', telefone: '', email: '', endereco: '', uf: '' });
  const [arquivos, setArquivos] = useState([]);
  const [previewArquivos, setPreviewArquivos] = useState([]);
  const [progresso, setProgresso] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, mensagem: '', tipo: 'success' });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.toUpperCase() });
  };

  const handleArquivoChange = (e) => {
    const files = Array.from(e.target.files);
    setArquivos(files);
    setPreviewArquivos(files.map(file => ({
      nome: file.name,
      tipo: file.type,
      tamanho: (file.size / (1024 * 1024)).toFixed(2),
      url: file.type.startsWith('image/') ? URL.createObjectURL(file) : null
    })));
  };

  const handleRemoverArquivo = (index) => {
    const novos = [...arquivos];
    novos.splice(index, 1);
    setArquivos(novos);
    setPreviewArquivos(novos.map(file => ({
      nome: file.name,
      tipo: file.type,
      tamanho: (file.size / (1024 * 1024)).toFixed(2),
      url: file.type.startsWith('image/') ? URL.createObjectURL(file) : null
    })));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      const uuid = await cadastrarCliente(formData, token);
      if (arquivos.length > 0) await enviarArquivos(uuid, arquivos, token);
      setSnackbar({ open: true, mensagem: 'Cliente adicionado com sucesso!', tipo: 'success' });
      setTimeout(() => navigate('/cadastros/clientes'), 2000);
    } catch (error) {
      console.error('Erro ao adicionar cliente:', error);
      setSnackbar({
        open: true,
        mensagem: `Erro: ${error?.response?.data?.mensagem || 'Erro desconhecido.'}`,
        tipo: 'error'
      });
    }
  };

  const cadastrarCliente = async (formData, token) => {
    const res = await axios.post(`${API_URL}/clientes`, formData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data.uuid;
  };

  const enviarArquivos = async (uuid, arquivos, token) => {
    const formData = new FormData();
    arquivos.forEach(arq => formData.append('arquivo', arq));

    await axios.post(`${API_URL}/clientes/${uuid}/arquivos`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (e) => {
        const pct = Math.round((e.loaded * 100) / e.total);
        setProgresso(pct);
      }
    });
  };

  const handleLimpar = () => {
    setFormData({ nome: '', cpf_cnpj: '', telefone: '', email: '', endereco: '', uf: '' });
    setArquivos([]);
    setPreviewArquivos([]);
    setProgresso(0);
  };

  return (
    <Box sx={{ backgroundColor: '#f5f5f5', minHeight: '100vh', py: 4, px: { xs: 2, sm: 3 } }}>
      <Container maxWidth="lg">
        <Box component="form" onSubmit={handleSubmit} sx={{ backgroundColor: '#fff', borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
          {/* HEADER GRADIENT */}
          <Box sx={{
            background: 'linear-gradient(135deg, #1f1f1f 0%, #f78b00 100%)',
            p: 3,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            color: '#fff'
          }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', flex: 1 }}>
              👤 ADICIONAR NOVO CLIENTE
            </Typography>
          </Box>

          <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* SEÇÃO 1: DADOS PESSOAIS */}
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1f1f1f', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                👤 DADOS PESSOAIS
              </Typography>
              <Box sx={{ 
                backgroundColor: '#f8f9fa', 
                p: 3, 
                borderRadius: 1.5, 
                border: '1px solid #e0e0e0',
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                gap: 2
              }}>
                <TextField
                  label="Nome Completo *"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  fullWidth
                  required
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                      '&:hover fieldset': { borderColor: '#f78b00' },
                      '&.Mui-focused fieldset': { borderColor: '#f78b00', borderWidth: 2 }
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#f78b00' }
                  }}
                />
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                  <TextField
                    label="CPF/CNPJ *"
                    name="cpf_cnpj"
                    value={formData.cpf_cnpj}
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: '#fff',
                        '&:hover fieldset': { borderColor: '#f78b00' },
                        '&.Mui-focused fieldset': { borderColor: '#f78b00', borderWidth: 2 }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: '#f78b00' }
                    }}
                  />
                </Box>
              </Box>
            </Box>

            {/* SEÇÃO 2: CONTATO */}
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1f1f1f', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                📞 CONTATO
              </Typography>
              <Box sx={{ 
                backgroundColor: '#f8f9fa', 
                p: 3, 
                borderRadius: 1.5, 
                border: '1px solid #e0e0e0',
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                gap: 2
              }}>
                <TextField
                  label="Telefone *"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  fullWidth
                  required
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                      '&:hover fieldset': { borderColor: '#f78b00' },
                      '&.Mui-focused fieldset': { borderColor: '#f78b00', borderWidth: 2 }
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#f78b00' }
                  }}
                />
                <TextField
                  label="Email *"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                  required
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                      '&:hover fieldset': { borderColor: '#f78b00' },
                      '&.Mui-focused fieldset': { borderColor: '#f78b00', borderWidth: 2 }
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#f78b00' }
                  }}
                />
              </Box>
            </Box>

            {/* SEÇÃO 3: ENDEREÇO */}
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1f1f1f', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                📍 ENDEREÇO
              </Typography>
              <Box sx={{ 
                backgroundColor: '#f8f9fa', 
                p: 3, 
                borderRadius: 1.5, 
                border: '1px solid #e0e0e0',
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: '1fr 200px' },
                gap: 2
              }}>
                <TextField
                  label="Endereço *"
                  name="endereco"
                  value={formData.endereco}
                  onChange={handleChange}
                  fullWidth
                  required
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                      '&:hover fieldset': { borderColor: '#f78b00' },
                      '&.Mui-focused fieldset': { borderColor: '#f78b00', borderWidth: 2 }
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#f78b00' }
                  }}
                />
                <FormControl fullWidth required>
                  <InputLabel sx={{ '&.Mui-focused': { color: '#f78b00' } }}>UF *</InputLabel>
                  <Select
                    name="uf"
                    value={formData.uf}
                    onChange={handleChange}
                    label="UF *"
                    sx={{
                      backgroundColor: '#fff',
                      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#f78b00' },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#f78b00', borderWidth: 2 }
                    }}
                  >
                    {estadosBrasil.map((uf) => (
                      <MenuItem key={uf} value={uf}>{uf}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>

            {/* SEÇÃO 4: ARQUIVOS */}
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1f1f1f', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                📎 ARQUIVOS (Opcional)
              </Typography>
              <Box sx={{ 
                backgroundColor: '#f8f9fa', 
                p: 3, 
                borderRadius: 1.5, 
                border: '1px solid #e0e0e0'
              }}>
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    background: 'linear-gradient(135deg, #1f1f1f 0%, #f78b00 100%)',
                    color: '#fff',
                    fontWeight: 'bold',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #0d0d0d 0%, #e67800 100%)'
                    }
                  }}
                >
                  Selecionar Arquivos
                  <input type="file" hidden multiple onChange={handleArquivoChange} />
                </Button>

                {previewArquivos.length > 0 && (
                  <List dense sx={{ mt: 2 }}>
                    {previewArquivos.map((arquivo, index) => (
                      <ListItem key={index} sx={{ bgcolor: '#fff', mb: 1, borderRadius: 1, border: '1px solid #e0e0e0' }}>
                        {arquivo.url ? (
                          <Avatar variant="square" src={arquivo.url} alt={arquivo.nome} sx={{ width: 48, height: 48, mr: 2 }} />
                        ) : (
                          <Avatar variant="square" sx={{ width: 48, height: 48, mr: 2, bgcolor: '#f78b00' }}>
                            📄
                          </Avatar>
                        )}
                        <ListItemText primary={arquivo.nome} secondary={`${arquivo.tipo} | ${arquivo.tamanho} MB`} />
                        <ListItemSecondaryAction>
                          <IconButton edge="end" color="error" onClick={() => handleRemoverArquivo(index)}>
                            <Delete />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                )}

                {progresso > 0 && progresso < 100 && (
                  <Box sx={{ mt: 2 }}>
                    <LinearProgress variant="determinate" value={progresso} />
                  </Box>
                )}
              </Box>
            </Box>

            {/* BOTÕES */}
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', pt: 2 }}>
              <Button
                variant="outlined"
                onClick={handleLimpar}
                sx={{
                  borderColor: '#1f1f1f',
                  color: '#1f1f1f',
                  fontWeight: 'bold',
                  '&:hover': { backgroundColor: '#f8f9fa' }
                }}
              >
                LIMPAR
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate('/cadastros/clientes')}
                sx={{
                  borderColor: '#999',
                  color: '#999',
                  fontWeight: 'bold',
                  '&:hover': { backgroundColor: '#f5f5f5' }
                }}
              >
                VOLTAR
              </Button>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  background: 'linear-gradient(135deg, #1f1f1f 0%, #f78b00 100%)',
                  color: '#fff',
                  fontWeight: 'bold',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #0d0d0d 0%, #e67800 100%)'
                  }
                }}
              >
                SALVAR
              </Button>
            </Box>
          </Box>
        </Box>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert severity={snackbar.tipo} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} variant="filled">
            {snackbar.mensagem}
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  );
}
